import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import YoutubeEmbed from './YoutubeEmbed';
import WistiaEmbed from './WistiaEmbed';
import YoukuEmbed from './YoukuEmbed';

import useTheme from '../SharedUtils/hooks';
import { getBackgroundField } from '../SharedUtils/themeColors';
import { useInvertedColor } from '../SharedUtils/hooks/useInvertedColor';

import './style.css';

const embedVideoComponents = {
  YouTube: YoutubeEmbed,
  Wistia: WistiaEmbed,
  YouKu: YoukuEmbed,
};

const TitleVideoCard = (props) => {
  const videoType = props.fields.VideoType?.fields?.value?.value || 'YouTube';
  const VideoEmbed = embedVideoComponents[videoType] || YoutubeEmbed;
  const videoId = props.fields.VideoID?.value;

  const widgetClassList = ['o-widget', 'c-title-video-card'];
  const widgetOverlayClassList = ['c-title-video-card__overlay__background'];
  const widgetStyleList = {};

  const { isLight } = useTheme();

  const backgroundfield = getBackgroundField(props.fields, isLight);
  const isColorInverted = useInvertedColor(props.fields);

  if (isColorInverted) {
    widgetClassList.push('is-inverted');
  }
  if (backgroundfield) {
    widgetOverlayClassList.push('u-' + backgroundfield?.value?.value);
  }

  if (props.fields.AddPadding?.value) {
    widgetClassList.push('has-padding');
  }
  if (props.fields.PlayerWidth?.value > 0) {
    widgetStyleList['width'] = props.fields.PlayerWidth?.value + 'px';
  }
  if (props.fields.PlayerHeight?.value > 0) {
    widgetStyleList['height'] = props.fields.PlayerHeight?.value + 'px';
  }

  return (
    <div
      id={`c-` + props.rendering?.uid}
      className={widgetClassList.join(' ')}
      style={widgetStyleList}
      data-widget="TitleVideoCard"
    >
      <div className="c-title-video-card__overlay">
        <span className={widgetOverlayClassList.join(' ')} tabIndex="-1"></span>
        <div
          tabIndex="0"
          className="c-title-video-card__overlay__title"
          data-component="VideoTitle"
        >
          <Text field={props.fields.Title} />
        </div>
        <div
          tabIndex="0"
          className="c-title-video-card__overlay__headline"
          data-component="VideoHeadline"
        >
          <Text field={props.fields.Headline} />
        </div>
      </div>

      <div className="c-title-video-card__video" data-component="VideoPlayer">
        <VideoEmbed videoId={videoId} width="100%" />
      </div>
    </div>
  );
};
export default TitleVideoCard;
